import { cn } from '../lib/utils';

const PriorityMatrix = ({ impactScore, effortScore, className }) => {
  // Calculate priority quadrant
  const getQuadrant = () => {
    const highImpact = impactScore >= 3;
    const lowEffort = effortScore <= 3;
    
    if (highImpact && lowEffort) return { label: 'Quick Win', color: 'bg-emerald-500', priority: 1 };
    if (highImpact && !lowEffort) return { label: 'Major Project', color: 'bg-blue-500', priority: 2 };
    if (!highImpact && lowEffort) return { label: 'Fill-In', color: 'bg-amber-500', priority: 3 };
    return { label: 'Thankless Task', color: 'bg-red-500', priority: 4 };
  };

  const quadrant = getQuadrant();

  if (!impactScore || !effortScore) {
    return (
      <div className={cn("text-sm text-slate-400", className)}>
        Not scored
      </div>
    );
  }

  return (
    <div className={cn("space-y-3", className)}>
      {/* Matrix Grid */}
      <div className="relative w-full aspect-square max-w-[200px] bg-slate-50 rounded-lg border border-slate-200 overflow-hidden">
        {/* Quadrant labels */}
        <div className="absolute inset-0 grid grid-cols-2 grid-rows-2">
          <div className="bg-blue-100/50 flex items-center justify-center p-1">
            <span className="text-[10px] text-blue-700 font-medium text-center">Major Project</span>
          </div>
          <div className="bg-emerald-100/50 flex items-center justify-center p-1">
            <span className="text-[10px] text-emerald-700 font-medium text-center">Quick Win</span>
          </div>
          <div className="bg-red-100/50 flex items-center justify-center p-1">
            <span className="text-[10px] text-red-700 font-medium text-center">Thankless</span>
          </div>
          <div className="bg-amber-100/50 flex items-center justify-center p-1">
            <span className="text-[10px] text-amber-700 font-medium text-center">Fill-In</span>
          </div>
        </div>
        
        {/* Position marker */}
        <div 
          className="absolute w-4 h-4 rounded-full bg-[#235894] border-2 border-white shadow-lg transform -translate-x-1/2 -translate-y-1/2 z-10"
          style={{
            left: `${(6 - effortScore) / 5 * 100}%`,
            top: `${(6 - impactScore) / 5 * 100}%`,
          }}
        />
        
        {/* Axis labels */}
        <div className="absolute bottom-0 left-0 right-0 text-center">
          <span className="text-[8px] text-slate-500">← High Effort | Low Effort →</span>
        </div>
        <div className="absolute top-0 bottom-0 left-0 flex items-center">
          <span className="text-[8px] text-slate-500 transform -rotate-90 whitespace-nowrap">High Impact ↑</span>
        </div>
      </div>

      {/* Score summary */}
      <div className="flex items-center gap-2">
        <span className={cn("px-2 py-1 rounded text-white text-xs font-medium", quadrant.color)}>
          {quadrant.label}
        </span>
        <span className="text-xs text-slate-500">
          Impact: {impactScore}/5 • Effort: {effortScore}/5
        </span>
      </div>
    </div>
  );
};

export default PriorityMatrix;
